<template>



<div class="wwf-petition-progress-container">
    <div id="wwf-petition-bar">
      <div id="wwf-petition-progress">
        <svg viewBox="0 0 600 160">
        <clipPath id="myClip">
         <rect  x="0" y="0" 
            :width="(revdirection)? '100%' : '0%'" 
            height="100%">

            <animate 
                attributeName="width" 
                :from="(revdirection)? '100%' : '0%'" 
                :to="(revdirection)? (100-percentage)+'%': percentage + '%'" 
                dur="3.5s" 
                fill="freeze" />
          </rect>
        </clipPath>
        <path id="straw" d="M2,125.9h433.1v31.2H2V125.9z M490.4,136.5l107-111.3l-21.3-22L468.4,114.5L490.4,136.5z M460.6,121.6
        l17.7,26.2l5-3.5l-18.4-26.2L460.6,121.6z M451.4,125.9l10.6,29.8l5-2.1l-10.6-29.8L451.4,125.9z M441.5,125.9h5.7v31.9h-5.7V125.9z" />

        <path id="strawColoured" d="M2,125.9h433.1v31.2H2V125.9z M490.4,136.5l107-111.3l-21.3-22L468.4,114.5L490.4,136.5z M460.6,121.6
        l17.7,26.2l5-3.5l-18.4-26.2L460.6,121.6z M451.4,125.9l10.6,29.8l5-2.1l-10.6-29.8L451.4,125.9z M441.5,125.9h5.7v31.9h-5.7V125.9z" fill="#00728f" />

        <use clip-path="url(#myClip)" xlink:href="#straw" fill="#00ACCD" />
        </svg>
      </div>
   <div> 
</div> 
    </div>
</div>
</template>
 
<script>
    export default {
        props: {
            percentage:Number,
            revdirection: {
            type: Boolean,
            default: false
            }
        },
        computed: {
            percent() { 
              return this.percentage.toFixed(); 
              }
        }
    }
</script> 
<style lang="css" scoped>
.wwf-petition-progress-container
{
    display: inline-block;
    width: 100%;
}

#wwf-petition-bar
{
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
}
#wwf-petition-progress
{  
     display: inline-block;
     width: 100%;
}


</style>




// WEBPACK FOOTER //
// Progressbar.vue?7b110676